import Vue from 'vue';
import InlineSvg from 'vue-inline-svg';
import OCPopup from 'containers/OCPopup.vue';
import OCPopupPreview from 'containers/OCPopupPreview.vue';

document.addEventListener('DOMContentLoaded', () => {
  Vue.component('InlineSvg', InlineSvg);
  const popupRoot = document.getElementById('popup-root');
  if (popupRoot) {
    const { userLastName } = popupRoot.dataset;
    new Vue({
      el: '#popup-root',
      render: (h) => h(OCPopup, { props: { userLastName } }),
    });
  }

  const element = document.getElementById('popup-preview-root');
  const propsJson = element?.dataset.props;
  if (propsJson) {
    const props = JSON.parse(propsJson);
    new Vue({
      el: '#popup-preview-root',
      render: (h) => h(OCPopupPreview, { props }),
    });
  }
});
